import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const WidgetSection = styled.section`
  height: 100%;
  border: solid 1px transparent;
  padding: 8px;
  margin: 0;
  cursor: pointer;

  &:hover {
    border: solid 1px var(--border-hover);
    border-radius: 8px;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: baseline;
  width: 100%;
  margin-bottom: 8px;
  ${typographyV2.bodySm}
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;
  width: 100%;
  height: 32px;
`;
